import { Box } from '@customerio/pluma-components/react';

/** Plan-choice step. Placeholder — content lands with FPS-2867. */
export function PlanChoiceStep() {
  return <Box data-testid="signup-step-plan-choice" />;
}
